import { environment } from '@environments/environment';

export class ManageProjectSetPortfoliosApiConstants {
  public static userUri = environment.serverUri + `api/${ environment.apiVersion }/system-admin/project-set-portfolios`;

  public static findAllProjectSetPorfolios = () => {
    return `${ ManageProjectSetPortfoliosApiConstants.userUri }/find-all`;
  };
}
